
import { CtepService } from "@/services/ctep-service";
import { TerminalOwner } from "@/utils/ctep/terminal-owner";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			nickname: "",
			isSaving: false
		};
	},
	props: {
		value: {
			type: Object as ()=>TerminalOwner,
			required: true
		}
	},
	watch: {
		terminal: {
			immediate: true,
			handler(){
				this.nickname = this.value.NickName;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.isSaving) return;
			this.isSaving = true;
			try{
				await CtepService.setNickname(this.value.TerminalID, this.nickname);
				this.$emit("refresh");
				this.close();
			}finally{
				this.isSaving = false;
			}
		}
	}
});
